/**
 * Edição de membro órfão.
 *
 * Salvar/Remover no topo, na linha do breadcrumb — mesmo padrão de
 * Sócios e Transações. A versão anterior editava um único campo "name",
 * que NÃO existe no modelo — todo salvar falhava no servidor. Agora os
 * campos reais do registro (nome, documento, contatos, matrícula) são
 * editáveis, o que permite corrigir um órfão (ex.: e-mail duplicado)
 * antes de criar o sócio a partir dele.
 */
import {
  EditContextProvider,
  SaveButton,
  SimpleForm,
  TextInput,
  useEditController,
} from "react-admin";
import { AppDeleteButton } from "../../components/AppDeleteButton";
import { useParams } from "react-router-dom";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";
import Grid from "@mui/material/Grid";
import { PageTopBreadcrumb } from "../../components/PageTopBreadcrumb";
import { determineUserReadableRole } from "../users/UserUtils";

export const OrphanedUsersEdit = (props: any) => {
  const { id } = useParams();
  const controller = useEditController({
    resource: "orphaned-users/crud",
    mutationMode: "pessimistic",
    id,
  });
  const isAdmin =
    determineUserReadableRole(localStorage.getItem("roles")) === "admin";

  const TopActions = () => (
    <>
      {isAdmin && <AppDeleteButton label="Remover" />}
      <SaveButton type="button" label="Salvar" />
    </>
  );

  return (
    <EditContextProvider value={controller}>
      {/* toolbar={false}: Salvar/Remover saem do rodapé e vão para o topo */}
      <SimpleForm toolbar={false}>
        <PageTopBreadcrumb
          title="Membros Órfãos"
          firstPath="/#/orphaned-users/crud"
          secondTitle="Editando"
          thirdTitle={
            controller && controller.record && controller.record.sNome
          }
          actionType="show"
          actions={<TopActions />}
        />
        <Card sx={{ padding: 2, marginBottom: 3, width: "100%" }}>
          <CardHeader title="Dados do Membro Órfão" />
          <CardContent>
            <Grid container columnSpacing={2} rowSpacing={0.5}>
              <Grid item xs={12} md={6}>
                {/* Chave do registro: protegida contra edição acidental
                    (o valor não é enviado no salvar) */}
                <TextInput
                  source="id"
                  label="ID"
                  fullWidth
                  helperText={false}
                  disabled
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextInput
                  source="oldId"
                  label="ID legado"
                  fullWidth
                  helperText={false}
                  disabled
                />
              </Grid>
              <Grid item xs={12}>
                <TextInput
                  source="sNome"
                  label="Nome"
                  fullWidth
                  helperText={false}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextInput
                  source="nCPF"
                  label="CPF"
                  fullWidth
                  helperText={false}
                />
              </Grid>
              <Grid item xs={6} md={3}>
                <TextInput
                  source="nMatricula"
                  label="Matrícula"
                  fullWidth
                  helperText={false}
                />
              </Grid>
              <Grid item xs={6} md={3}>
                <TextInput
                  source="nDigito"
                  label="Dígito"
                  fullWidth
                  helperText={false}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextInput
                  source="sEmailPart"
                  label="E-mail"
                  fullWidth
                  helperText={false}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextInput
                  source="sCelular"
                  label="Celular"
                  fullWidth
                  helperText={false}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextInput
                  source="sTelResid"
                  label="Telefone residencial"
                  fullWidth
                  helperText={false}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                {/* Texto livre de propósito: os valores gravados variam
                    ("CONTA PROVISÓRIA", "DUPLICATED EMAIL"…) e um seletor
                    fechado poderia apagar silenciosamente valores fora
                    da lista */}
                <TextInput
                  source="issueReason"
                  label="Razão do erro"
                  fullWidth
                  helperText={false}
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </SimpleForm>
    </EditContextProvider>
  );
};
